<template>
    <div>
        <div class="col-lg-12">
            <div class="row">
                <div class="col-lg-12">
                    <div class="row">
                        <div class="col-lg-4 m-1">
                            <date-range-picker
                                class="w-100"
                                :opens="'center'"
                                :min-date="minDate"
                                :max-date="maxDate"
                                :singleDatePicker="false"
                                :appendToBody="true"
                                :ranges="false"
                                :closeOnEsc="false"
                                :autoApply="true"
                                :locale-data="{ format: 'dd-mm-yyyy' }"
                                v-model="time">
                            </date-range-picker>
                        </div>

                        <div class="col-lg-4 m-1">
                            <select class="form-control" v-model="expressCode">
                                <option value="" disabled selected>请选择快递公司</option>
                                <option :value="item.expressCode" v-for="(item,index) in expressList" :key="index">{{item.expressCode}}</option>
                            </select>
                        </div>

                        <div class="col-lg-2 m-1">
                            <button class="btn btn-info btn-sm-res" @click="queryPickupAnalysis">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>

                        <b-table
                            ref="reportDelivery"
                            show-empty
                            responsive
                            :items="tableData"
                            :fields="fields"
                            :per-page="pageSize"
                            :busy="busy"
                            selectable
                            select-mode="multi"
                            class="scroll-bar-pop text-center"
                            empty-text="暂无数据"
                            empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                        >
                            <template slot="createTime" slot-scope="{item}">
                                <span v-if="item.pickupInformation.expressCode === 'FLASH' || item.pickupInformation.expressCode === 'THAIPOST'">{{item.pickupInformation.createTime}}</span>
                                <span v-if="item.pickupInformation.expressCode !== 'FLASH'">{{item.pickupInformation.pickTime}}</span>
                            </template>
                            <template slot="noticeState" slot-scope="{item}">
                                <b-badge variant="status-parcel-warning"
                                    v-if="item.pickupInformation.state === '0'"
                                >
                                    {{ item.pickupInformation.stateText }}
                                </b-badge>
                                <b-badge variant="status-parcel-warning"
                                    v-if="item.pickupInformation.state === '1'"
                                >
                                    {{ item.pickupInformation.stateText }}
                                </b-badge>
                                <b-badge variant="status-parcel-success"
                                    v-if="item.pickupInformation.state === '2'"
                                >
                                    {{ item.pickupInformation.stateText }}
                                </b-badge>
                                <b-badge variant="status-parcel-success"
                                    v-if="item.pickupInformation.state === '3'"
                                >
                                    {{ item.pickupInformation.stateText }}
                                </b-badge>
                                <b-badge variant="status-parcel-danger"
                                    v-if="item.pickupInformation.state === '4'"
                                >
                                    {{ item.pickupInformation.stateText }}
                                </b-badge>
                                <b-badge variant="status-parcel-success"
                                    v-if="item.pickupInformation.expressCode !== 'FLASH' && item.pickupInformation.expressCode !== 'THAIPOST'"
                                >
                                    取消
                                </b-badge>
                            </template>
                            <template slot="staffInfo" slot-scope="{ item }">
                                <div v-if="item.pickupInformation.expressCode === 'FLASH'">
                                    <div>{{ item.pickupInformation.staffInfoName + `(${item.pickupInformation.staffInfoId})` }}</div>
                                    <div>{{ item.pickupInformation.staffInfoPhone }}</div>
                                </div>
                                <span v-if="item.pickupInformation.expressCode === 'THAIPOST'">02-831-3131</span>
                                <span v-if="item.pickupInformation.expressCode === 'NINJA'">02-026-1499</span>
                                <!-- <span v-if="row.pickupInformation.expressCode === 'THAIPOST'">02-831-3131</span> -->
                                <span v-if="item.pickupInformation.expressCode === 'SCG'">02-239-8999</span>
                                <span v-if="item.pickupInformation.expressCode === 'SCG8'">02-239-8999</span>
                                <span v-if="item.pickupInformation.expressCode === 'SCG15'">02-239-8999</span>
                                <span v-if="item.pickupInformation.expressCode === 'ECO'">02-831-3131</span>
                                <span v-if="item.pickupInformation.expressCode === 'DHL'">02-029-0999</span>
                            </template>
                            <template slot="pkgCount" slot-scope="{ item }">
                                <span>{{item.pkgCount}} / {{item.pkgPrintedCount}}</span>
                            </template>
                            <template slot="timeoutAtText" slot-scope="{ item }">
                                <span v-if="item.pickupInformation.expressCode === 'FLASH' || item.pickupInformation.expressCode === 'THAIPOST'">{{item.pickupInformation.timeoutAtText}}</span>
                            </template>
                            <template slot="action" slot-scope="{ item }">
                                <b-button variant="danger" size="sm"
                                    v-if="item.pickupInformation.state !== '4'&& item.pickupInformation.state !== '2' && (item.pickupInformation.expressCode ==='FLASH' || item.pickupInformation.expressCode ==='THAIPOST')"
                                    @click="fnCancelNotice(item)"
                                >
                                    取消通知
                                </b-button>

                                <b-button variant="success" size="sm"
                                    v-if="item.pickupInformation.state !== '4'"
                                    @click="fnCreatePickupOrder(item)"
                                >
                                    生成揽件单
                                </b-button>
                                <b-button variant="primary" size="sm"
                                    type="primary"
                                    @click="fnLookPickupList(item)"
                                >
                                    查看揽件单
                                </b-button>
                            </template>
                        </b-table>
                        <div class="mt-3" style="display: flex;justify-content: end;width: 100%">
                            <b-pagination
                                :total-rows="totalItem"
                                :current-page="pageIndex"
                                :per-page="pageSize"
                                :value="pageIndex"
                                @input="changePage"
                                align="right">
                            </b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal
            centered
            hide-footer
            v-model="fnLookPickupListOptions.visible"
            size="lg"
            title="揽件单历史"
        >
            <b-table
                ref="reportDelivery"
                show-empty
                responsive
                :items="tableDataHistory"
                :fields="fieldsHistory"
                selectable
                select-mode="multi"
                class="scroll-bar-pop text-center"
                empty-text="暂无数据"
                empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
            >
                <template slot="index" slot-scope="{item}">
                    <span>{{item.index + 1}}</span>
                </template>
                <template slot="createTime" slot-scope="{item}">
                    <span>{{item.createTime}}</span>
                </template>
                <template slot="fileName" slot-scope="{item}">
                    <span>{{item.downloadUrl}}</span>
                </template>
                <template slot="action" slot-scope="{item}">
                    <b-button variant="success" size="sm"
                        @click="handleDownload(item)"
                    >
                        下载
                    </b-button>
                </template>
            </b-table>
        </b-modal>
    </div>
</template>
<script>
import moment from "moment";
import {expressList} from "@/api/express";
import {cancleNoticeCourier, exportPickupRecord, getAddressAgentList, queryPickupAnalysis} from "@/api/noticePackage";

export default {
    data() {
        return {
            tableDataHistory: [],
            fieldsHistory: [
                {key: 'index', label: '序号', sortable: true},
                {key: 'createTime', label: '下载时间', sortable: true},
                {key: 'fileName', label: 'file Name', sortable: true},
                {key: 'action', label: '操作', sortable: true},
            ],
            totalItem: 0,
            pageSize: 10,
            pageIndex: 1,
            tableData: [],
            fields: [
                {key: 'expressCode', label: '快递公司', sortable: true},
                {key: 'createTime', label: '呼叫时间', sortable: true},
                {key: 'noticeState', label: '揽件状态', sortable: true},
                {key: 'staffInfo', label: '快递员信息', sortable: true},
                {key: 'pkgCount', label: '揽件数量', sortable: true},
                {key: 'timeoutAtText', label: '上门揽件时间', sortable: true},
                {key: 'action', label: '操作', sortable: true},
            ],
            busy: false,
            time: {
                startDate: "",
                endDate: "",
            },
            expressCode: "",
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
            expressList: [],
            fnLookPickupListOptions: {
                visible: false,
                data: ""
            }
        }
    },
    mounted() {
        this.getExpressList();
        this.queryPickupAnalysis();
    },
    methods: {
        handleDownload(row){
            var downloadElement = document.createElement("a"); //创建一个<a></a>标签
            downloadElement.href = row.downloadUrl; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
            // a.download = "下载啦.xlsx"; //设置下载文件文件名，这里加上.xlsx指定文件类型，pdf文件就指定.fpd即可
            downloadElement.style.display = "none"; // 障眼法藏起来a标签
            document.body.appendChild(downloadElement); // 将a标签追加到文档对象中
            downloadElement.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
            downloadElement.remove(); // 一次性的，用完就删除a标签
        },
        // 查看揽件单历史
        fnLookPickupList(row){
            console.log(row);
            this.fnLookPickupListOptions.data = row.excelUrl
            this.fnLookPickupListOptions.visible = true
        },
        fnCreatePickupOrder(row) {
            exportPickupRecord({
                expressCode:row.pickupInformation.expressCode
            }).then(res => {
                if (res.data.url) {
                    window.open(res.data.url, "_blank");
                }
            });
        },
        fnCancelNotice(item) {
            this.$bvModal
                .msgBoxConfirm(`确定撤销揽件通知？ `, {
                    title: "提示",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "ยืนยัน",
                    cancelTitle: "ยกเลิก",
                    contentClass: "modal-confirm",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true
                })
                .then(() => {
                    cancleNoticeCourier({
                        pickId: item.pickupInformation.id,
                    }).then(res => {
                        this.queryPickupAnalysis();
                    });
                }).catch(() => {

            })

        },
        queryPickupAnalysis() {
            this.busy = true;
            let param = {
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                startTime: this.time.startDate ? moment(this.time.startDate).format("YYYY-MM-DD") + " 00:00:00" : undefined,
                endTime: this.time.endDate ? moment(this.time.endDate).format("YYYY-MM-DD") + " 23:59:59" : undefined,
                expressCode: this.expressCode
            }
            queryPickupAnalysis(param).then(res => {
                this.tableData = res.data.records;
                this.totalItem = res.data.total;
                this.busy = false;
            });
        },
        changePage(i) {
            if (this.pageIndex == i) return;
            this.pageIndex = i
            this.queryPickupAnalysis()
        },
        getExpressList() {
            expressList().then(res => {
                this.expressList = res.data;
            });
        }
    }
}
</script>
<style scoped>

</style>
